import { ReactElement } from "react";

interface IndicatorNumberProps {
    label: string;
    value: number;
    unitOfMeasure: string;
    decimalPlaces?: number;
}

const IndicatorNumber = (props: IndicatorNumberProps): ReactElement =>
{
    return (
        <div>
            <div className="value">
                <span>{props.value.toFixed(props.decimalPlaces || 0)}</span>
                <span className="unitOfMeasure">{props.unitOfMeasure}</span>
            </div>
            <div className="label">{props.label}</div>
        </div>
    );
}

export default IndicatorNumber;